import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import classNames from 'classnames/bind';
import CouponDetailsModalAction from '../../actions/CouponDetailsModalAction';
import * as styles from './CouponCard.css';
import AnalyticsAction from '../../actions/AnalyticsAction';
import { COUPON_TOGGLE_DETAILS_IRIS_COUPON_DETAILS } from '../../common/Constants';
import CouponListAction from '../../actions/CouponListAction';
import { selectDeviceType, selectFeatureFlags } from '../../selectors/ContextSelector';

const cx = classNames.bind(styles);

export class CouponDetails extends Component {
    static propTypes = {
        disclaimer: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
            PropTypes.string,
            PropTypes.bool,
        ]),
        offerDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        actions: PropTypes.object.isRequired,
        promoCode: PropTypes.string,
        detailsText: PropTypes.string,
        useInlineDetails: PropTypes.bool,
        prepareRenderer: PropTypes.func,
        detailsPerCodeTheme: PropTypes.string,
        couponDetailsWrapperTheme: PropTypes.string,
        couponDetailsModal: PropTypes.bool,
        couponSlot: PropTypes.number,
        doMobileShowDetailByUser: PropTypes.func,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isCouponDrawer: PropTypes.bool,
        featureFlags: PropTypes.object.isRequired,
    };

    static defaultProps = {
        disclaimer: '',
        couponVariant: 'Default',
        offerDetails: [],
        actions: {},
        promoCode: '',
        detailsText: null,
        useInlineDetails: false,
        prepareRenderer: null,
        detailsPerCodeTheme: '',
        couponDetailsWrapperTheme: '',
        couponDetailsModal: false,
        couponSlot: 0,
        doMobileShowDetailByUser: null,
        deviceType: {},
        isCouponDrawer: false,
        featureFlags: {},
    };

    constructor() {
        super();
        this.state = { showDetails: false };
    }

    componentDidMount() {
        if (this.props.useInlineDetails) {
            this.props.prepareRenderer(this.renderCouponDetails);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.useInlineDetails && !this.props.useInlineDetails) {
            this.props.prepareRenderer(this.renderCouponDetails);
        }
    }

    toggleCouponDetails = () => {
        const showDetailsState = this.state.showDetails;
        const isMobile = get(this.props, 'deviceType.isMobile', false);
        const isNewDetailsModalOpen = this.props.couponDetailsModal === this.props.couponSlot;
        /* istanbul ignore else */
        if (this.props.useInlineDetails && !isMobile) {
            this.props.actions.openDetailsModal(
                isNewDetailsModalOpen ? false : this.props.couponSlot
            );
        }
        /** Analytics Tracking starts new details */
        /* istanbul ignore else */
        if (!isNewDetailsModalOpen) {
            this.props.actions.trackCouponSeeDetail();
        }
        /** Analytics Tracking ends new details */

        isMobile && this.props.doMobileShowDetailByUser && this.props.doMobileShowDetailByUser();

        this.setState({
            showDetails: !showDetailsState,
        });

        /* istanbul ignore next */
        if (!showDetailsState && !this.props.useInlineDetails) {
            /** Analytics Tracking starts old details modal */
            const modalAnalyticsMessage = 'opened coupon detail';
            this.props.actions.openModelEvent({ name: modalAnalyticsMessage });
            /** Analytics Tracking ends old details modal */
        }
    };

    renderCouponDetails = () => {
        const couponDetailsHtml = [];
        let key = 0;
        const offers = this.props.offerDetails;
        const isMobile = get(this.props, 'deviceType.isMobile', false);
        const {
            isCouponDrawer,
            featureFlags: { disableDetailsHeadlineCouponDrawer = false },
        } = this.props;
        offers.forEach((offerItem, index) => {
            const { bodyCopy, headLine } = offerItem;

            if (isMobile || !isCouponDrawer || !disableDetailsHeadlineCouponDrawer) {
                /** {Pushing Coupon Info HTml in Here} */
                couponDetailsHtml.push(
                    <div
                        data-automation-id={`at-coupon-count-${key}`}
                        key={(key += 1)}
                        className={this.props.detailsPerCodeTheme}
                    >
                        {' '}
                        {headLine ? (
                            /* istanbul ignore next */
                            <h4 data-automation-id="at-coupon-name" className={cx('couponCode')}>
                                {index
                                    ? `${offerItem.conjunction || 'OR'} ${headLine}`
                                    : `*${headLine}`}
                            </h4>
                        ) : (
                            ''
                        )}
                        <p
                            data-automation-id="at-coupon-description"
                            className={cx('couponCodeDetails')}
                        >
                            {
                                /* istanbul ignore next */
                                bodyCopy || ''
                            }
                        </p>
                    </div>
                );
            }
        });

        /* eslint-disable react/no-danger */
        couponDetailsHtml.push(
            <div
                className={`${cx(
                    'couponDetailsWrapper',
                    {
                        couponDetailsForDesktopTablet:
                            !isMobile && isCouponDrawer && disableDetailsHeadlineCouponDrawer,
                    },
                    this.props.couponDetailsWrapperTheme
                )} ${dt(['max-h-[calc(100vh-220px)]'])}`}
                dangerouslySetInnerHTML={{ __html: this.props.disclaimer }}
            />
        );

        return couponDetailsHtml;
    };

    render() {
        if (!this.props.disclaimer) return null;
        const { deviceType, promoCode, useInlineDetails, detailsText, isCouponDrawer } = this.props;
        // blocking to send isMobile & isTablet to avaoid scrolling the page to top when See detail clicked
        let deviceTypeInfo = {
            isDesktop: deviceType.isDesktop,
        };
        // send isMobile & isTablet only for coupon page to avaoid scrolling main page when Modal opened
        if (!isCouponDrawer && !deviceType.isDesktop) {
            deviceTypeInfo = { ...deviceType };
        }

        const promoCodeValue = promoCode || 'instore coupons';
        return (
            <div
                className={cx('detailsContainer')}
                id={`${useInlineDetails ? 'couponDrawer|' : ''}See Details|${promoCodeValue}`}
            >
                <Button
                    automationId="at-show-hide-details"
                    buttonType="Link"
                    className={cx('showHideDtlBtn')}
                    size="Md"
                    onClick={this.toggleCouponDetails}
                >
                    {detailsText || COUPON_TOGGLE_DETAILS_IRIS_COUPON_DETAILS}
                </Button>
                {!useInlineDetails && (
                    <ModalBox
                        showModal={this.state.showDetails}
                        renderModalToBody
                        deviceType={deviceTypeInfo}
                        onClose={this.toggleCouponDetails}
                        defaultHeader
                        modalOverlayTheme={cx('modalOverlayTheme')}
                        modalBlockTheme={cx('modalbox-height')}
                        modalTheme={dt(['!max-h-[calc(100vh-220px)]'])}
                        automationId="at-cpn-serial-modal"
                        wrapperAutomationId="coupon-see-detials-popup"
                        modalContentTheme={[
                            cx('ModalContentTheme'),
                            dt(['smMd:max-h-[calc(100vh-330px)]', 'lg:!max-h-[calc(100vh-350px)]']),
                        ].join(' ')}
                    >
                        {this.renderCouponDetails()}
                    </ModalBox>
                )}
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            openModelEvent: AnalyticsAction.openModelEvent,
            openDetailsModal: CouponDetailsModalAction.openDetailsModal,
            trackCouponSeeDetail: CouponListAction.trackCouponSeeDetail,
        },
        dispatch
    ),
});

const mapStateToProps = (state) => ({
    deviceType: selectDeviceType(state),
    featureFlags: selectFeatureFlags(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponDetails);
